import React from 'react';
import styles from './CarbonEmissionScale.module.scss';

const CarbonEmissionScale = () => {
  return (
    <div className={styles.scaleContainer}>
      <p>Carbon Emission</p>
      <div className={styles.labelContainer}>
        <p>Low</p>
        <p>High</p>
      </div>
      <div className={styles.scale}>
        <div className={styles.blue}>
          <div className={styles.legendContainer}>
            <p>0</p>
            {/* <p>20</p> */}
          </div>
        </div>
        <div className={styles.green}>
          <div className={styles.legendContainer}>
            <p>20</p>
          </div>
        </div>
        <div className={styles.yellow}>
          <div className={styles.legendContainer}>
            <p>40</p>
          </div>
        </div>
        <div className={styles.brown}>
          <div className={styles.legendContainer}>
            <p>60</p>
          </div>
        </div>
        <div className={styles.red}>
          <div className={styles.legendContainer}>
            <p>80</p>
            <p className={styles.extraMargin}>100</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarbonEmissionScale;
